import {Link} from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import LineChart from './LineChart';
import React,{ useState,useEffect,useContext } from 'react';
import { VendorContext } from '../../context';
import { Activity, Calendar, ChevronDown, CreditCard, Gift, Package, Plus, Users} from 'react-feather';
import { FaFacebook, FaTwitter, FaWhatsapp, FaCopy, FaEyeSlash, FaEye } from "react-icons/fa";
import Sidebar from './sidebar';
import api from "../api";
import { ExchangeRateContext } from '../../ExchangeRateContext';
import useStoreSetupCheck from './useStoreSetupCheck';
import { QRCodeCanvas } from "qrcode.react";
import FileUploadComponent from './FileUploadComponent';
import ReorderAgentCard from './ReorderAgentCard';
function SellerDashboard(){   
    useStoreSetupCheck();
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl0 = process.env.REACT_APP_BASE_URL_IMG;
    const vendorContext=useContext(VendorContext);
    const [OrderItems,setOrderItems]=useState([]);   
    const [StockItems,setStockItems]=useState([]);
    const [ProductViewsData,setProductViewsData]=useState([]);
    const [ProductViewsDataLength, setProductViewsDataLength] = useState(true);
    const [dashboardOpen, setDashboardOpen] = useState(false);
    const [VendorData, setVendorData] = useState(() => {
        const savedData = localStorage.getItem('VendorData');
        return savedData ? JSON.parse(savedData) : {
            'r_run':0,
            'totalProducts': 0,
            'totalOrders': 0,
            'subTotalOrders': 0,
            'totalCustomers': 0,
            'name': '',
            'loc': '',
            'bal': '...',
            'totalTraffic': '...',
            'payMode': '',
            'payMode1': '',
            'payMode2': '',
        };
    });
    const navigate = useNavigate();
    const [vendorCurrency, setVendorCurrency] = useState(
        localStorage.getItem("VendorCurrency") || ""
    );
    const [showBalance, setShowBalance] = useState(false);
    const { exchangeRates, baseCurrency } = useContext(ExchangeRateContext);
    const [stats, setStats] = useState({
        units_sold: 0,
        total_sales: 0,
        lifetime_revenue: 0,
    });
    const [filter, setFilter] = useState("week");

    const fetchData = async () => {
        try {
          const response = await api.get(`${baseUrl}/vendor-dashboard/`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          });
          setVendorData(response.data);
        } catch (err) {
          //console.error("Error fetching products:", err.toJSON());
        }
    };    

    const fetchOrders = async () => {
        try {
          const response = await api.get(`${baseUrl}/vendor-orderitems/?fetch_limit=6`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          });
          setOrderItems(response.data.order_items);
          setVendorCurrency(response.data.vendor_currency);
        } catch (error) {
          //console.error("Error fetching products:", err.toJSON());
        }
    };

    const fetchProductViewsData = async () => {
        try {
          const response = await api.get(`${baseUrl}/most-viewed-products/`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          });
          setProductViewsData(response.data.most_viewed_products);
          setProductViewsDataLength(response.data.total_results);
        } catch (error) {
          //console.error("Error fetching products:", err.toJSON());
        }
    };
    
    const fetchStock = async () => {
        try {
          const response = await api.get(`${baseUrl}/vendor-products/dash/products/`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          });
          setStockItems(response.data.products);
        } catch (error) {
          //console.error("Error fetching products:", err.toJSON());
        }
    };
    useEffect(() => {
        fetchStats(filter);
    }, [filter]);

    const fetchStats = async (filterOption) => {
        try {
            const response = await api.get(`/vendor-sales-stats-reports/?filter=${filterOption}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` },
            });
            setStats(response.data);
        } catch (error) {
            //console.error("Error fetching stats:", error);
        }
    };

    // Update localStorage whenever VendorData changes
    useEffect(() => {
        localStorage.setItem('VendorData', JSON.stringify(VendorData));
    }, [VendorData]);

    useEffect(() => {
        fetchData();
        fetchOrders();
        fetchProductViewsData();
        fetchStock();
        const savedPref = localStorage.getItem('showBalance');
        setShowBalance(savedPref === 'true');
    }, []);

    useEffect(() => {
        if(vendorCurrency) {
            localStorage.setItem("VendorCurrency", vendorCurrency);
            localStorage.setItem("baseCurrency", vendorCurrency);
        }
    }, [vendorCurrency]);

    const formatDate = (date) => {
        const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        
        const dayName = days[date.getDay()];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
    
        const getOrdinalSuffix = (day) => {
            if (day > 3 && day < 21) return 'th';
            switch (day % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        };
    
        return `${dayName}, ${day}${getOrdinalSuffix(day)} ${month}, ${year}`;
    };
    const currentDate = new Date();
    var shop_level = "";var shop_level_val = "";
    if(VendorData.totalProducts<10){
        shop_level="Starter";shop_level_val="10%";
    }else if(VendorData.totalProducts<20){shop_level="Bronze";shop_level_val="20%";}else if(VendorData.totalProducts<50){shop_level="Silver";shop_level_val="60%";}
    else if(VendorData.totalProducts<150){shop_level="Gold";shop_level_val="80%";}else if(VendorData.totalProducts<250){shop_level="Platinum";shop_level_val="100%";}

    var rtgcard = "";
    if(VendorData.r_run>0){
        rtgcard="ACTIVE";
    }else{
        if(VendorData.subTotalOrders>0){
            rtgcard="HAS_ORDERS";
        }else{
            rtgcard="NO_ORDERS";
        }
    }
    
    const getVendorCurrency = () => {
        return localStorage.getItem("VendorCurrency");
    };
     const [copied, setCopied] = useState(false);
    const vendor_username = localStorage.getItem('vendor_shopname') || "Kadhr";
    const vendor_shoplink = localStorage.getItem('vendor_username') || "Kadhr";
    
    var shopName  = vendor_username;
    var shopLink  = 'https://kadhr.com/'+vendor_shoplink;

    const shareText = `Wassgud, ${shopName} here, we got some cool merchandise in our store, Check us out on ${shopLink}`;
    const socialLinks = {
        whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(shareText)}`,
        twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shopLink)}`,
        instagram: "https://www.instagram.com/", // Instagram doesn't allow direct URL sharing
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(shopLink);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset message after 2 seconds
    };

    const toggleBalance = () => {
        const newValue = !showBalance;
        setShowBalance(newValue);
        localStorage.setItem('showBalance', newValue);
    };
    return (
        <> 
            <Helmet>
                <title>Dashboard - {shopName} </title>
                <meta name="description" content={`Manage Shop`} />
            </Helmet>
            <section className="container mtopcon dashb">
                <div className="row">
                    <div className="col-12 col-lg-2 dash-min mb-3">
                        <div className="nav-left-sidebar sidebar-dark pc">
                            <div className="slimScrollDiv" ><div className="menu-list" >
                                <nav className="navbar navbar-expand-lg navbar-light nav-l-con">
                                    <a className="d-xl-none d-lg-none" href="#"></a>
                                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                        <span className="navbar-toggler-icon"></span>
                                    </button>
                                    <div className="collapse navbar-collapse" id="navbarNav">
                                        <Sidebar/>
                                    </div>
                                </nav>
                            </div><div className="slimScrollBar"></div><div className="slimScrollRail"></div></div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-10 dash-max">                    
                        <div className="row dash-top-row hdmobile">
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12"></div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-6 hdmobile">
                                <div className="row dash-top-row mb-4">
                                    <ul className="h-100 p-0">
                                        {VendorData.rr == 0 && <Link to="/seller/addproduct"><li className='float-right h-100'><button className='btn btn-primary h-100 br50r'><Plus className='me-2'/>New Product</button></li></Link>}                                    
                                        <li className='float-right h-100 me-3 topdate'><Calendar/><p className='float-right'> {formatDate(currentDate)}</p></li>
                                    </ul>                                
                                    
                                </div>
                            </div>
                        </div>
                        <div className="row dashhome-rw">
                            <div className='col-lg-4 col-12 mb-4'> 
                                <div
                                    className="row containerzz mb-2"
                                    style={{ cursor: "pointer" }}
                                >
                                    {/* HEADER */}
                                    <div
                                        className="d-flex justify-content-between align-items-center mb-2"
                                        onClick={() => setDashboardOpen((prev) => !prev)}
                                    >
                                        <div>
                                            <h3 className="mb-0">
                                                Hey, <span className="tcone">{VendorData.name}</span>
                                            </h3>
                                            <p className="font9 mb-0">Your business command center is ready.</p>
                                        </div>

                                        <ChevronDown
                                            size={24}
                                            style={{
                                                transition: "0.2s ease",
                                                transform: dashboardOpen
                                                    ? "rotate(180deg)"
                                                    : "rotate(0deg)",
                                            }}
                                        />
                                    </div>

                                    {/* CONTENT */}
                                    {dashboardOpen && (
                                        <div className="grid pb-2">
                                                <Link to="/seller/orders" className=''>
                                                    <div className="card">
                                                        <div className='row w-100'>
                                                            <div className='col-3 text-center text-white p-0'><Gift className='navstaticon'/></div>
                                                            <div className='col-9 pr-0 plpt'><h4 className="text font90x mb-0 text-white">Orders</h4></div>
                                                            <div className='col-3 text-right text-white p-0'></div>
                                                            <div className='col-9'><h2 className="mb-1 text-white mb-0">{VendorData.totalOrders}</h2></div>
                                                        </div>
                                                    </div>
                                                </Link>
                                                <Link to="/seller/products" className=''>
                                                    <div className="card">
                                                        <div className='row w-100'>
                                                            <div className='col-3 text-center text-white p-0'><Package className='navstaticon'/></div>
                                                            <div className='col-9 pr-0 plpt'><h4 className="text font90x mb-0 text-white">Current Stock</h4></div>
                                                            <div className='col-3 text-right text-white p-0'></div>
                                                            <div className='col-9'><h2 className="mb-1 text-white mb-0">{VendorData.totalProducts}</h2></div>
                                                        </div>
                                                    </div>
                                                </Link>
                                                <Link to="/seller/reports" className=''>
                                                    <div className="card">
                                                        <div className='row w-100'>
                                                            <div className='col-3 text-center text-white p-0'><Users className='navstaticon'/></div>
                                                            <div className='col-9 pr-0 plpt'><h4 className="text font90x mb-0 text-white">Visits Today</h4></div>
                                                            <div className='col-3 text-right text-white p-0'></div>
                                                            <div className='col-9'><h2 className="mb-1 text-white mb-0">{VendorData.totalTraffic}</h2></div>
                                                        </div>
                                                    </div>
                                                </Link>
                                                
                                                <div className="card">
                                                    <div className="row w-100">
                                                        <div className="col-3 text-center text-white p-0">
                                                        <CreditCard className="navstaticon" />
                                                        </div>

                                                        <div className="col-7 plpt">
                                                        <h4 className="text font90x mb-0 text-white">Balance</h4>
                                                        </div>

                                                        <div className="col-2 text-right text-white p-0">
                                                        {showBalance ? (
                                                            <FaEyeSlash onClick={toggleBalance} className="cursor-pointer" />
                                                        ) : (
                                                            <FaEye onClick={toggleBalance} className="cursor-pointer" />
                                                        )}
                                                        </div>

                                                        <div className="col-12 mt-1">
                                                        <h2 className="mb-0 text-white">
                                                            {showBalance
                                                            ? Intl.NumberFormat().format(VendorData.bal)
                                                            : '******'}
                                                        </h2>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                        </div>
                                    )}
                                </div>  
                                <div className="row mt-4">  
                                    <ReorderAgentCard state={rtgcard}/>
                                </div>
                            </div>
                            <div className='col-lg-4 col-12'>                                 
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header font1 border-0">
                                            <div className='row p-0 m-0'>
                                                <p className='pl-3 m-0 col-11 fbold'>Realtime Shop Visits </p>
                                                {VendorData.rr == 0 && <div className='col-5 text-right display-none'><Link to="/seller/reports" className='fgreen'><button className='btn btn-primary p-1 w-auto'><Activity/> Analytics</button></Link></div>}
                                            </div>
                                        </div>                                            
                                        <div className="card-body p-1">
                                            <LineChart
                                                chart_title=""
                                                chart_categories={stats.shop_visits?.categories || []}
                                                chart_data={stats.shop_visits?.data || []}
                                            />
                                        </div>
                                    </div>
                                </div>                          
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header font1 border-0">
                                            <div className='row p-0 m-0'>
                                                <p className='pl-3 m-0 col-11 fbold'>Weekly Revenue Overview </p>
                                            </div>
                                        </div> 
                                        <div className="card-body p-1">
                                            <LineChart
                                                chart_title=""
                                                chart_categories={stats.revenue_overview?.categories || []}
                                                chart_data={stats.revenue_overview?.data || []}
                                            />
                                        </div>
                                    </div>
                                </div>   
                            </div>
                            <div className='col-lg-4 col-12'>
                                 
                                {ProductViewsDataLength>0 && ProductViewsData.length === 0 ? (                                    
                                    <>
                                        <div className="col-12 pt-2">
                                            <div className="card bg-default dsktp-ord br-0n">
                                                <h6 className="font-bold mb-0 pt-0">Most Viewed Products Today</h6>
                                                <div className="card-body font9 grey-text">
                                                    <p>No products viewed yet.</p>                                               
                                                </div>
                                            </div>
                                        </div> 
                                    </>
                                ) : (
                                    <>
                                        <div className="col-12 pt-2">
                                            <div className="card bg-default dsktp-ord br-0n">
                                                <h6 className="font-bold mb-0 pt-0">Most Viewed Products Today</h6>
                                                <div className="card-body">
                                                    {ProductViewsDataLength>0 && ProductViewsData.map((item,index)=>{ 
                                                        return <div className="row ord-bg bg-white p-2 hvr bx-shadow" key={index}>
                                                            <div className="col-2 p-0"><div className="ord-img br-10"><img src={`${baseUrl0}/${item.first_image_url}`} className='w-100 h-100'/></div></div>
                                                            <div className="col-9 ml-2 pl-0 pr-0">
                                                                <div className="row">
                                                                    <div className="col-11 ord-sz-dsk">{item.product_name}</div>
                                                                    <div className="col-6 ord-sz-dsk text-primary"><span className="badge rounded-pill text-bg-secondary">Visits: {item.view_count}</span></div>
                                                                    <div className="col-6 ord-sz-dsk grey-text">                                                                            
                                                                        <span className='cart-pro-ttl'>{getVendorCurrency()} {item.product_price}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>                                                            
                                                    })}                                                
                                                </div>
                                            </div>
                                        </div> 
                                    </>
                                )}
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="container d-flex justify-content-center mt-3">
                                                <div className="card shadow-none text-center rounded" style={{ maxWidth: "400px", width: "100%" }}>
                                                    {/* Shop Name */}
                                                    <h3 className="fw800">{shopName}</h3>
                
                                                    {/* QR Code */}
                                                    <div className="my-3">
                                                    <QRCodeCanvas value={shopLink} size={200} />
                                                    </div>
                
                                                    {/* Copy Link */}
                                                    <div className="mt-4 text-center mb-4"><button className="main-btn-mini btn-outline text-dark bg-white border-dark border-5 font-bold"  onClick={copyToClipboard}><FaCopy /> {copied ? "Copied!" : "Copy Link"}</button></div>                                                  
                                                    <hr/>
                                                    <h6 className="mt-3">Share On</h6>
                                                    {/* Share Buttons */}
                                                    <div className="d-flex justify-content-around mt-2 font9 pb-4">
                                                        <a href={socialLinks.whatsapp} target="_blank" rel="noopener noreferrer" className="btn btn-success br-10 p-3 ms-2">
                                                            <FaWhatsapp size={24} />
                                                        </a>
                                                        <a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer" className="btn btn-info p-3 br-10 text-white ms-2">
                                                            <FaTwitter size={24} />
                                                        </a>
                                                        <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer" className="btn btn-primary br-10 p-3 ms-2">
                                                            <FaFacebook size={24} />
                                                        </a>
                                                    </div>
                                                    <hr/>
                                                    
                                                    <div className='row'>
                                                        <div className='col-12 mt-2'>
                                                            <div className="metric-value d-inline-block">
                                                                <h6 className="mb-3">Shop Level : {shop_level}</h6>
                                                            </div>
                                                            <div className="progress prgrss br50r mb-3">
                                                                <div className="progress-bar" role="progressbar" aria-valuemin="0"  style={{ width: shop_level_val }} aria-valuemax="100"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        
                    </div>
                </div>
                
                <div className="modal fade" id="addorder" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog mt70">
                            <div className="modal-content">
                                <div className="modal-body pb-4">        
                                    <div className="mb-0">
                                        <FileUploadComponent route_page={'dashboard'}/>  
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SellerDashboard;